import { BaseApi } from '@bv/api';

interface QueueListItem {
  number: string;
  name: string;
  type: 'inbound' | 'outbound';
  agents: { name: string; number: string }[];
}

interface QueueListResponse {
  data: QueueListItem[];
  meta: {
    timezone: string;
  };
}

class VoipQueueApi extends BaseApi {
  public constructor(public endpoint = 'reports/elements') {
    super(endpoint);
  }

  public async list(): Promise<QueueListResponse> {
    return this.request<QueueListItem, QueueListResponse>({
      method: 'get',
    });
  }
}

export const voipQueueApi = new VoipQueueApi();
